import { Chat, Message, User, Venue } from "sweet-global";
export const RESET_CHAT = "chat/RESET_CHAT";
export const GET_CHATS_INIT = "chat/GET_CHATS_INIT";
export const GET_CHATS_SUCCESS = "chat/GET_CHATS_SUCCESS";
export const GET_CHATS_FAILURE = "chat/GET_CHATS_FAILURE";
export const CREATE_CHAT_INIT = "chat/CREATE_CHAT_INIT";
export const CREATE_CHAT_SUCCESS = "chat/CREATE_CHAT_SUCCESS";
export const CREATE_CHAT_FAILURE = "chat/CREATE_CHAT_FAILURE";
export const SEND_MESSAGE_INIT = "chat/SEND_MESSAGE_INIT";
export const SEND_MESSAGE_SUCCESS = "chat/SEND_MESSAGE_SUCCESS";
export const SEND_MESSAGE_FAILURE = "chat/SEND_MESSAGE_FAILURE";
export const ADD_CHAT_MESSAGES = "chat/ADD_CHAT_MESSAGES";
export const REMOVE_CHAT_MESSAGE = "chat/REMOVE_CHAT_MESSAGE";
export const DELETE_CHAT = "chat/DELETE_CHAT";

export interface ChatState {
  chats: { [chatId: string]: Chat };
  archivedChats: { [chatId: string]: Chat };
  chatUsers: { [userId: string]: User };
  chatVenues: { [venueId: string]: Venue };
  chatMessages: {
    [chatId: string]: {
      [messageId: string]: Message;
    };
  };
  isGettingChats: boolean;
  successGettingChats: boolean;
  errorGettingChats: Error | null;
  isCreatingChat: boolean;
  successCreatingChat: boolean;
  errorCreatingChat: Error | null;
  isSendingMessage: boolean;
  successSendingMessage: boolean;
  errorSendingMessage: Error | null;
}

interface ResetChatAction {
  type: typeof RESET_CHAT;
}
interface GetChatsInitAction {
  type: typeof GET_CHATS_INIT;
}

interface GetChatsSuccessAction {
  type: typeof GET_CHATS_SUCCESS;
  chats: {
    [chatId: string]: Chat;
  };
  archivedChats: {
    [chatId: string]: Chat;
  };
  chatUsers?: {
    [userId: string]: User;
  };
  chatVenues?: {
    [venueId: string]: Venue;
  };
}

interface GetChatsFailureAction {
  type: typeof GET_CHATS_FAILURE;
  error: Error;
}

interface CreateChatInitAction {
  type: typeof CREATE_CHAT_INIT;
}

interface CreateChatSuccessAction {
  type: typeof CREATE_CHAT_SUCCESS;
}

interface CreateChatFailureAction {
  type: typeof CREATE_CHAT_FAILURE;
  error: Error;
}

interface DeleteChatAction {
  type: typeof DELETE_CHAT;
  chatId: string;
}

interface SendMessageInitAction {
  type: typeof SEND_MESSAGE_INIT;
}

interface SendMessageSuccessAction {
  type: typeof SEND_MESSAGE_SUCCESS;
}

interface SendMessageFailureAction {
  type: typeof SEND_MESSAGE_FAILURE;
  error: Error;
}

interface AddChatMessagesAction {
  type: typeof ADD_CHAT_MESSAGES;
  chatId: string;
  messages: {
    [messageId: string]: Message;
  };
}

interface RemoveChatMessageAction {
  type: typeof REMOVE_CHAT_MESSAGE;
  chatId: string;
  messageId: string;
}

export type ChatActionTypes =
  | ResetChatAction
  | GetChatsInitAction
  | GetChatsSuccessAction
  | GetChatsFailureAction
  | CreateChatInitAction
  | CreateChatSuccessAction
  | CreateChatFailureAction
  | DeleteChatAction
  | SendMessageInitAction
  | SendMessageSuccessAction
  | SendMessageFailureAction
  | AddChatMessagesAction
  | RemoveChatMessageAction;
